import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import { useContext } from "react"
import { GlobalContext } from '../_app'

import _ from 'lodash'

import Head from 'next/head'

import handleContentBlocks from "../../lib/content-blocks"
import handleSeomaticMeta from "../../lib/seomatic"
import { 
    QueryPageHeader,
    QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QuerySEO,
    QueryImages,
	QuerySpacer,
	QueryProfileGroups,
} from "../../graphql/queries"

import { Header, HeaderShim } from '../../fuselage/global/header/header'
import { Footer } from '../../fuselage/theme/2024/layout/footer/footer'

function Speakers({ seomatic, contentBlocks }) {

	const globals = useContext(GlobalContext)

	console.log('contentBlocks:', contentBlocks)


	return (
		<>

			<Head>
				{ handleSeomaticMeta( seomatic ) }  
            </Head>

			<Header mainMenu={globals.nodes} />
			<HeaderShim />

			{ handleContentBlocks( contentBlocks ) }

			<Footer 
				socialConnections={globals.globalSets[2].socialConnections} 
				contactInfo={globals.globalSets[2].contactDetails[0].body}
				hubspotForm={globals.globalSets[2].hubspotForm[0] ? globals.globalSets[2].hubspotForm[0] : null}
			/>
		</>
	)
}
Speakers.theme = 'aviadev-2024'

export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: "53930") {
					... on ${process.env.SITE_HANDLE}Speakers_${process.env.SITE_HANDLE}Speakers_Entry {
						id
						title
						slug
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPageHeader}
							${QueryText}
							${QueryFlipFlops}
							${QueryFloaters}
							${QueryBillboards}
							${QueryBillboardSliders}
							${QueryImpactFigures}
							${QueryVideos}
							${QueryProfileCarousel}
							${QueryForm}
							${QueryImages}
							${QuerySpacer}
							${QueryProfileGroups}
						}
						${QuerySEO}
					}
				}
			}
        `
    })



	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			contentBlocks: cmsData.data.entry.aviadevContentBlocks,
		}
	}
}

export default Speakers


